import type { ChatymeEmbedHostMessageTypeValue } from '../constants/chatymeEmbedHostMessageTypes';

/**
 * Posts a message to the embedding page when this app runs inside an iframe.
 * The parent can listen with: window.addEventListener('message', (e) => { ... }).
 *
 * @param targetOrigin - Passed to `postMessage`; if set and not `*`, a failed send is retried with `*`.
 */
export function postChatEmbedHostMessage(
  data: Record<string, unknown> & { type: ChatymeEmbedHostMessageTypeValue },
  targetOrigin: string = '*'
): void {
  try {
    if (typeof window === 'undefined' || window.parent === window) {
      return;
    }
    window.parent.postMessage(data, targetOrigin);
  } catch (err) {
    if (targetOrigin !== '*') {
      postChatEmbedHostMessage(data, '*');
    } else {
      console.error('postChatEmbedHostMessage failed', err);
    }
  }
}
